<template>
	<listarray ref="listarray" page="segment"></listarray>
</template>

<script>
import listarray from "@/components/globalVue/ListArray.vue";
export default {
	name: "Segments",
	components: {
		listarray: listarray,
	},
};
</script>
